module.exports = __webpack_public_path__ + "img/errormark.3c33c8e3.png";